import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { isMobile } from "./deviceUtils";
import './styles.css';

export function showEstruturasInvalidasAlert (onConfirmation?: Function, onClose?: Function) {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: [
      'Para prosseguir com a seleção do módulo FINAME, ',
      'é obrigatório informar o tipo de estrutura do projeto. ', 
      'Para continuar, utilize a opção “Editar Estrutura” e selecione o tipo de estrutura adequado.'
    ],
    title: "Atenção!",
    size: isMobile() ? 'auto' : "440px",
    yesText: 'OK',
    propagateWhenConfirm: true,
    onClose: () => {
      confirmationDialog.close();
      if (onClose) onClose();
    },
    onConfirmation: () => {
      if(onConfirmation) onConfirmation();
    },
    className: 'show-estruturas-invalidas-alert'
    // headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();

}